export const MapaMaza = () => {
  return (

    
    <iframe
        title="Puerto Pichilingue"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d331372.07754552935!2d-107.18009267324395!3d23.417915667365566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x869f5393e4afb043%3A0xe71d0ebd60c94d1f!2sBaja%20Ferries!5e0!3m2!1ses!2smx!4v1700263965490!5m2!1ses!2smx"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        zoom={5}


    />
  )
}
export default MapaMaza;